<div class="module-message-wrap" v-if="uid"><ItemMessageRoom :messageRoomId="$route.params.messageRoomId"></ItemMessageRoom></div>